import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";
import FieldDropdownLazyLoading from "../../dropdown-lazy-loading";
import FieldDropdownLazyLoading_FormView from "./form-view";


export default function FieldDropdownLazyLoading_FormElementView(props: FieldFormElementViewProps) {

    const value = props.model[props.field.fieldId]

    return <FieldDropdownLazyLoading_FormView className      = {props.className}
                             field          = {props.field as unknown as FieldDropdownLazyLoading}
                             value          = {value}
                             configOptions  = {props.options}
                             disabled       = {props.disabled}
                             onChange       = {props.onChange}/>

}